import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from "clsx";
const BRAND_MARK_AVIF = "/brand-mark.avif";
const BRAND_MARK_PNG = "/brand-mark.png";
/**
 * Renders the square GRUV ticket G brand mark with AVIF-first delivery.
 */
export function GruvLogoMark({ className, priority = false, width = 64, height = 64, ...props }) {
    return (_jsxs("picture", { className: "gruv-logo-mark", children: [_jsx("source", { srcSet: BRAND_MARK_AVIF, type: "image/avif" }), _jsx("img", { src: BRAND_MARK_PNG, alt: "GRUV", width: width, height: height, className: clsx("gruv-logo-mark__image", className), fetchPriority: priority ? "high" : undefined, ...props })] }));
}
